import cloudflareImageLoader from '@repo/utils/image-loader';

export default cloudflareImageLoader;
